import { Salt, TenantIdKey, TokenKey } from '@/config/'
import md5 from 'blueimp-md5'
import Cookies from 'js-cookie'

// expires see: https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions#expire-cookies-in-less-than-a-day
// 接口返回的 token 有效期目前为 1 天
const oneDay = 1
// const testMinutes = new Date(new Date().getTime() + 2 * 60 * 1000) //For test 2 minutes

export function getSign(signParam) {
  return md5(`${signParam}@${Salt}`)
}

export function setToken(token) {
  // stk use for private upload file to be read
  Cookies.set('stk', token.token, { expires: oneDay })
  Cookies.set('stk', token.token, { expires: oneDay, sameSite: 'none', secure: true })
  Cookies.set('_yycx_admin_assets', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_finance', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_order', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_app_custom', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_ccs', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_bi', token.token, { expires: oneDay })
  Cookies.set('_yycx_admin_acl', token.token, { expires: oneDay })
  Cookies.set('_che_admin_tk', token.token, { expires: oneDay })
  return Cookies.set(TokenKey, token, { expires: oneDay })
}

export function setCompanyId(companyId) {
  return Cookies.set('companyId', companyId)
}

export function getCompanyId() {
  return Cookies.get('companyId')
}

export function getTokenObj() {
  return Cookies.getJSON(TokenKey) || {}
}

export function getToken() {
  const { token = '' } = getTokenObj()
  return token
}

export function getTokenExpires() {
  const { expiration = 0 } = getTokenObj()
  return expiration
}

export function removeToken() {
  removeTenantId()
  Cookies.remove('stk')
  Cookies.remove('_yycx_admin_assets')
  Cookies.remove('_yycx_admin_finance')
  Cookies.remove('_yycx_admin_order')
  Cookies.remove('_yycx_admin_app_custom')
  Cookies.remove('_yycx_admin_ccs')
  Cookies.remove('_yycx_admin_bi')
  Cookies.remove('_yycx_admin_acl')
  Cookies.remove('_che_admin_tk')

  return Cookies.remove(TokenKey)
}

export function setTenantId(tenantId) {
  Cookies.set('_order_tenant_id', tenantId)
  Cookies.set('_assets_tenant_id', tenantId)
  Cookies.set('_finance_tenant_id', tenantId)
  Cookies.set('_app_custom_tenant_id', tenantId)
  Cookies.set('_css_tenant_id', tenantId)
  Cookies.set('_bi_tenant_id', tenantId)
  return Cookies.set(TenantIdKey, tenantId)
}

export function getTenantId() {
  return Cookies.get(TenantIdKey) || -1
}

export function removeTenantId() {
  Cookies.remove('_order_tenant_id')
  Cookies.remove('_assets_tenant_id')
  Cookies.remove('_finance_tenant_id')
  Cookies.remove('_app_custom_tenant_id')
  Cookies.remove('_css_tenant_id')
  Cookies.remove('_bi_tenant_id')

  return Cookies.remove(TenantIdKey)
}

export function getLogoImg() {
  switch (getTenantId()) {
    case '800001':
      return 'https://cdn.cheweijia.com/public/695ed96a5de048f392f550a18e400dc3.png'
    case '800002':
      return 'https://cdn.cheweijia.com/public/ff19ddc3510243f495405daf5a37e9c3.png'
    default:
      return 'https://cdn.cheweijia.com/client/delivery/202203261405/cheweijia.png'
  }
}

export function getLogoTextImg() {
  switch (getTenantId()) {
    case '800001':
      return 'https://cdn.cheweijia.com/public/c345d689fc9749f08c1407c2ace8f206.png'
    case '800002':
      return 'https://cdn.cheweijia.com/public/96c9b4f9b17e4257b5f3d54454072cb2.png'
    default:
      return 'https://cdn.cheweijia.com/public/96c9b4f9b17e4257b5f3d54454072cb2.png'
  }
}
// 跳转回welcome
export function gotoNewWindow() {
  // const a = window.location.pathname.split('/')
  const newA = `${window.origin}/`
  window.location.href = newA
}

export function setResourceFailedNum(init = false) {
  const count = init ? 0 : getResourceFailedNum() + 1
  localStorage.setItem('resFailedCount', count)
}

export function getResourceFailedNum() {
  const count = localStorage.getItem('resFailedCount') || 0
  return Number(count)
}
